export const MessageVariables: Array<{ id: string; label: string }> = [
  {
    id: 'program_name',
    label: 'Program name',
  },
  {
    id: 'program_address',
    label: 'Program address',
  },
  {
    id: 'program_city',
    label: 'Program city',
  },
  {
    id: 'program_region',
    label: 'Program region',
  },
  {
    id: 'program_country',
    label: 'Program country',
  },
  {
    id: 'event_name',
    label: 'Event name',
  },
  {
    id: 'event_starts_at',
    label: 'Event starts at',
  },
  {
    id: 'event_ends_at',
    label: 'Event ends at',
  },
  {
    id: 'event_date_range',
    label: 'Event date range',
  },
  {
    id: 'contact_name',
    label: 'Contact name',
  },
  {
    id: 'contact_first_name',
    label: 'Contact first name',
  },
  {
    id: 'contact_last_name',
    label: 'Contact last name',
  },
  {
    id: 'contact_address',
    label: 'Contact address',
  },
  {
    id: 'contact_city',
    label: 'Contact city',
  },
  {
    id: 'contact_region',
    label: 'Contact region',
  },
  {
    id: 'contact_country',
    label: 'Contact country',
  },
  {
    id: 'contact_postcode',
    label: 'Contact postcode',
  },
  {
    id: 'contact_email',
    label: 'Contact email',
  },
  {
    id: 'attendee_name',
    label: 'Attendee name',
  },
  {
    id: 'attendee_first_name',
    label: 'Attendee first name',
  },
  {
    id: 'attendee_last_name',
    label: 'Attendee last name',
  },
  {
    id: 'attendee_email',
    label: 'Attendee email',
  },
  {
    id: 'attendee_gender',
    label: 'Attendee gender',
  },
]
